export default "__VITE_ASSET__92bd4160__"